/**
 * Debug Logger - 兼容层
 * 内部使用persistentLogger，保持API兼容性
 *
 * 注意：此文件已废弃，请直接使用 persistentLogger
 * import { pLogger } from '@/utils/persistentLogger';
 */

import { pLogger } from './persistentLogger';

/**
 * @deprecated 请使用 persistentLogger
 * 此类仅为保持向后兼容，内部调用 persistentLogger
 */
class DebugLogger {
  private readonly storageKey = 'crm-debug-logs';

  /**
   * @deprecated 使用 pLogger.log(category, message)
   */
  log(message: string, ...args: unknown[]) {
    if (import.meta.env.PROD) return; // 生产环境不写日志，避免存储与控制台噪音
    if (args.length > 0) {
      message = `${message} ${args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : String(arg)).join(' ')}`;
    }
    const match = message.match(/^([\u{1F300}-\u{1F9FF}])\s*(.+)$/u);
    if (match) {
      const categoryMap: Record<string, string> = {
        '📝': 'LOGIN', '📡': 'API', '🎉': 'LOGIN', '✅': 'SUCCESS', '❌': 'ERROR',
        '🚀': 'NAVIGATION', '📊': 'STORE', '🏁': 'COMPLETE', '🔍': 'DEBUG',
        '💧': 'HYDRATE', '⏳': 'LOADING', '🔒': 'AUTH', '👤': 'USER',
      };
      const category = categoryMap[match[1]] || 'DEBUG';
      pLogger.log(category, match[2]);
    } else {
      pLogger.log('DEBUG', message);
    }
    const timestamp = new Date().toISOString().split('T')[1].substring(0, 12);
    console.log(`[${timestamp}] ${message}`);
  }

  /**
   * @deprecated 使用 window.debugLogs.print()
   */
  getLogs(): string[] {
    console.warn('⚠️ debugLogger.getLogs() is deprecated. Use window.debugLogs.print() instead');
    return [];
  }

  /**
   * @deprecated 使用 window.debugLogs.clear()
   */
  clear() {
    console.warn('⚠️ debugLogger.clear() is deprecated. Use window.debugLogs.clear() instead');
    pLogger.clear();
  }

  /**
   * @deprecated 使用 window.debugLogs.print()
   */
  showAll() {
    console.warn('⚠️ debugLogger.showAll() is deprecated. Use window.debugLogs.print() instead');
    return pLogger.printLogs();
  }

  /**
   * @deprecated 使用 window.debugLogs.export()
   */
  export(): string {
    console.warn('⚠️ debugLogger.export() is deprecated. Use window.debugLogs.export() instead');
    return pLogger.exportLogs();
  }
}

export const debugLogger = new DebugLogger();

// 显示废弃警告
if (typeof window !== 'undefined') {
  console.warn(
    '%c⚠️ debugLogger is DEPRECATED',
    'color: orange; font-weight: bold; font-size: 14px',
    '\nPlease migrate to persistentLogger:\n' +
    'import { pLogger } from \'@/utils/persistentLogger\';\n' +
    'pLogger.log(\'CATEGORY\', \'message\', data);'
  );
}
